module.exports = __webpack_public_path__ + "img/test_b.9d6b2a94.png";